/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const getMTDSummaryReport = (params, otherOptions) =>
  makeApiCall(`/ninety-report/mdt-summary`, 'POST', params, false, otherOptions);

export const getWeeklySummaryReport = (params, otherOptions) =>
  makeApiCall(`/ninety-report/weekly-report`, 'POST', params, false, otherOptions);

export const getPerMDSummaryReport = (params, otherOptions) =>
  makeApiCall(`/ninety-report/per-md-report`, 'POST', params, false, otherOptions);

export const postExportMTDSummaryReport = (params, otherOptions) =>
  makeApiCall(`/ninety-report/mdt-summary/export`, 'POST', params, false, otherOptions);

export const postExportWeeklySummaryReport = (params, otherOptions) =>
  makeApiCall(`/ninety-report/weekly-report/export`, 'POST', params, false, otherOptions);

export const postExportPerMDSummaryReport = (params, otherOptions) =>
  makeApiCall(`/ninety-report/per-md-report/export`, 'POST', params, false, otherOptions);

/* FILTER */

export const getFilterDepartment = (params) =>
  makeApiCall(`/user/departments/list`, 'GET', params, false);

export const getFilterTeams = (params) => makeApiCall(`/user/teams`, 'POST', params, false);

export const getFilterManager = (params) =>
  makeApiCall(`/user/managers/list`, 'POST', params, false);

export const getFilterRep = (params) => makeApiCall(`/user/reps/list`, 'POST', params, false);
